import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVER_API_URL, SERVICE_HUBSPOT_API_URL } from '@app/app.constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class HubspotService {
  constructor(private http: HttpClient) {}

  contactServices(body: any): Observable<any> {
    return this.http.post(SERVER_API_URL + `public/services/hubspot`, body);
  }

  postToHubspot(
    hubspotData: any,
    portalId: string,
    formId: string
  ): Observable<any> {
    return this.http.post(
      `${SERVICE_HUBSPOT_API_URL}${portalId}/${formId}`,
      JSON.stringify(hubspotData),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  async submitToHubspot(
    hubspotData: any,
    portalId: string,
    formId: string
  ): Promise<Response> {
    const url = `${SERVICE_HUBSPOT_API_URL}${portalId}/${formId}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(hubspotData),
    });
    return response;
  }
}
